import _Vue, { PluginObject } from 'vue'
import dayjs from './dayjs.plugin'

export default {
  install(Vue: typeof _Vue) {
    Vue.prototype.$dayjs = dayjs
  }
} as PluginObject<never>
